import { TFunction } from 'i18next';
import { FilterGroup } from 'shared/types/filter';
import { Goal } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';
import { Tag } from 'shared/types/tag';
import { createPriorityFilter } from 'shared/utils/filters/create-priority-filter';

import { createDurationFilter } from './create-duration-filter';
import { createGoalFilter } from './create-goal-filter';
import { createLifeAreaFilter } from './create-life-area-filter';
import { createTagFilter } from './create-tag-filter';
import { createTypeFilter } from './create-type-filter';

export type Options = {
  t: TFunction;
  goals: Goal[];
  lifeAreas: LifeArea[];
  tags: Tag[];
};

export const createFilters = ({
  t,
  goals,
  lifeAreas,
  tags,
}: Options): FilterGroup[] => {
  const lifeAreaFilters = createLifeAreaFilter(lifeAreas, { t });

  const goalFilters = createGoalFilter(goals, { t });

  const tagFilters = createTagFilter(tags, { t });

  const priorityFilters = createPriorityFilter({ t });

  const typeFilters = createTypeFilter({ t });

  const durationFilter = createDurationFilter({ t });

  return [
    {
      id: 'filters',
      title: t('context-menus.filtering.task.filters.title'),
      filters: [
        ...lifeAreaFilters,
        ...goalFilters,
        ...tagFilters,
        priorityFilters,
        typeFilters,
        durationFilter,
      ],
    },
  ];
};
